<template>
  <el-dialog
    :model-value="visible"
    destroy-on-close
    width="580px"
    top="20vh"
    :before-close="handleClose"
    class="resource_dialog"
    :close-on-click-modal="false"
    :title="'申请使用'"
  >
    <el-form ref="form" :model="formData" :rules="formRules" label-width="100px" class="form" label-position="left">
      <!-- <el-form-item label="企业名称" prop="ename">
        <el-input v-model="formData.ename" maxlength="50" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item> -->
      <el-form-item label="联系人姓名" prop="contactName">
        <el-input v-model="formData.contactName" maxlength="50" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="formData.phone" maxlength="30" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item>

      <el-form-item label="企业名称" prop="ename">
        <el-input v-model="formData.ename" maxlength="50" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item>

      <!-- <el-form-item label="用户名" prop="userName">
        <el-input v-model="formData.userName" maxlength="50" autocomplete="off" placeholder="请输入" size="large" />
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model="formData.password"
          maxlength="30"
          autocomplete="off"
          placeholder="请输入"
          size="large"
          show-password
        />
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPassWord">
        <el-input
          v-model="formData.checkPassWord"
          maxlength="30"
          autocomplete="off"
          placeholder="请再次输入新密码"
          size="large"
          show-password
        />
      </el-form-item> -->
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="formLoading" @click="submitForm(form)">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive, ref } from 'vue';
import { euserApply } from '@/data/ApiPersonnel';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ['update:visible'],
  setup(props, ctx) {
    const form = ref();
    const formLoading = ref(false);
    const router = useRouter();
    let formData = ref({
      // userName: undefined,
      contactName: undefined,
      phone: undefined,
      ename: undefined,
      // password: undefined,
      // checkPassWord: undefined,
    });

    const validatePass = (rule, value, callback) => {
      if (value !== formData.value.password) {
        callback(new Error('新密码两次输入不一致'));
      } else {
        callback();
      }
    };

    const reset = () => {
      formData.value = {
        // userName: undefined,
        contactName: undefined,
        phone: undefined,
        ename: undefined,
        // password: undefined,
        // checkPassWord: undefined,
      };
    };

    const formRules = reactive({
      userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
      ename: [{ required: false, message: '请输入企业名称', trigger: 'blur' }],
      contactName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
      phone: [{ required: true, message: '请输入正确手机号', trigger: 'blur', pattern: /^1[3456789]\d{9}$/ }],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        {
          pattern: /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/,
          message: '请输入至少6位,包含大小写字母数字特殊字符的密码',
          trigger: 'blur',
        },
      ],
      checkPassWord: [
        { required: true, message: '请再次输入新密码', trigger: 'blur' },
        {
          validator: validatePass,
          trigger: 'blur',
        },
      ],
    });

    //表单操作
    const handleClose = () => {
      reset();
      ctx.emit('update:visible', false);
    };
    const submitForm = (form) => {
      form.validate((valid) => {
        if (valid) {
          euserApply({
            ...formData.value,
            // checkPassWord: undefined,
          })
            .then((res) => {
              ElMessage.success('申请成功');
              handleClose();
              // setTimeout(() => {
              //   router.push({ name: 'login' });
              // }, 100);
              // ctx.emit('update:visible', false);
            })
            .finally(() => {
              handleClose();
              formLoading.value = false;
            });
        } else {
          return false;
        }
      });
    };
    return {
      form,
      formRules,
      formData,
      formLoading,
      handleClose,
      submitForm,
      validatePass,
    };
  },
};
</script>
<style lang="scss" scoped></style>
